import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { usrRole } from "../../utils/dataUtil";
import { Card, Select, message } from "antd";
import {
  req_list_ssp_target_principal,
  req_list_ssp_school_source_detail,
  req_add_school_plan_detail,
} from "../../api";
const { Option } = Select;

class StudentSourceAddModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    obj: PropTypes.object.isRequired,
  };

  state = {
    isUpdate: false,
    isInsert: false,
    row: {
      Gid: "",
      YearMonth: "",
      PlanAcademicYear: "",
      AcademicSystem: "四技",
      UniversityCode: "1051",
      CollegeCode: "",
      TargetDepartmentCode: "",
      PrincipalCode: "",
      SourceCode: "",
      HighSchoolCode: "",
      SourceDepartmentCode: "",
      NumberOfPeople: 0,
      RecordCreatorId: "",
      RecordEditorId: "",
    },
    colleges: [
      // { label: "管理學院", value: "59" },
      { label: "生活科技學院", value: "60" },
      { label: "設計學院", value: "62" },
      { label: "藝術學院", value: "63" },
      // { label: "旅遊學院", value: "193" },
    ],
    targetdeparts: [
      { value: "187", label: "應用英語系", group: "60" },
      { value: "196", label: "旅館管理系", group: "60" },
      { value: "214", label: "養生休閒管理系", group: "60" },
      { value: "161", label: "企業管理系", group: "60" },
      { value: "24", label: "資訊管理系", group: "60" },
      { value: "7", label: "國際企業經營系", group: "60" },
      { value: "8", label: "財務金融系", group: "60" },
      { value: "165", label: "餐飲系", group: "60" },
      { value: "178", label: "生活服務產業系", group: "60" },
      { value: "199", label: "運動休閒與健康管理系", group: "60" },
      { value: "3", label: "服飾設計管理系", group: "60" },
      { value: "4", label: "美容造型設計系", group: "60" },
      { value: "5", label: "幼兒保育系", group: "60" },
      { value: "11", label: "室內設計系", group: "62" },
      { value: "159", label: "時尚設計系", group: "62" },
      { value: "164", label: "多媒體動畫系", group: "62" },
      { value: "17", label: "視覺傳達設計系", group: "62" },
      { value: "18", label: "商品設計系", group: "62" },
      { value: "212", label: "漫畫系", group: "63" },
      { value: "19", label: "美術系", group: "63" },
      { value: "20", label: "音樂系", group: "63" },
      { value: "21", label: "舞蹈系", group: "63" },
      { value: "213", label: "流行音樂系", group: "63" },
    ],
    targetdepartlist: [],
    targetprincipals: [],
    sourcedeparts: [],
    academicSystems: [
      { label: "四技", value: "四技" },
      { label: "七技", value: "七技" },
    ],
    sourceCodes: [
      { value: "AA", label: "商管群(A)" },
      { value: "AB", label: "餐旅群(A)" },
      { value: "AC", label: "設計群(A)" },
      { value: "AD", label: "藝術群(A)" },
      { value: "AE", label: "機械群(A)" },
      { value: "AF", label: "食品群(A)" },
      { value: "AG", label: "土木群(A)" },
      { value: "AH", label: "外語群英語類(A)" },
      { value: "AI", label: "電子與電機群資電類(A)" },
      { value: "AJ", label: "家政群生活應用類(A)" },
      { value: "AK", label: "家政群幼保類(A)" },
      { value: "AM", label: "農業類(A)" },
      { value: "BA", label: "藝術單招(B1)" },
      { value: "BB", label: "特殊選才(B2)" },
      { value: "BC", label: "繁星入學(B3)" },
      { value: "BD", label: "運優單招(B4)" },
      { value: "BE", label: "一般獨招(B5)" },
      { value: "CA", label: "四技申請(高中生)(C)" },
      { value: "DA", label: "技優甄審(D)" },
    ],
    selectedCollege: "NONE",
    selectedTargetdepart: "NONE",
    selectedTargetprincipal: "NONE",
    selectedAcademicSystem: "四技",
    selectedSourceCode: "NONE",
    selectedSourceDepartmentCode: "NONE",
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.init();
  }

  componentDidMount() {}

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_target_depart = (value) => {
    const result = this.state.targetdeparts.filter(function (el) {
      return el.group === value;
    });
    const targetdepartlist = result.length > 0 ? result : [];
    this.setState({ targetdepartlist });
    //console.log("targetdepartlist:", targetdepartlist);
  };

  api_list_target_principal = async (targetDepart) => {
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    const result = await req_list_ssp_target_principal(
      userCode,
      userLevel,
      targetDepart,
      token
    );
    const targetprincipals = result.total > 0 ? result.data : [];
    this.setState({ targetprincipals });
    // console.log("targetprincipals:", targetprincipals);
  };

  api_list_source_depart = async () => {
    const { obj } = this.props;
    const { planAcademicYear, highSchoolCode } = obj;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ loading: true, userLevel: userLevel });
    const result = await req_list_ssp_school_source_detail(
      userCode,
      userLevel,
      planAcademicYear,
      highSchoolCode,
      token
    );
    const sourcedeparts = result.total > 0 ? result.data : [];
    this.setState({ sourcedeparts });
  };

  api_add_item = async (item) => {
    const { token } = this.props.user;
    this.setState({ loading: true });
    const result = await req_add_school_plan_detail(item, token);
    this.setState({ loading: false });
    if (result.status === "success") {
      // console.log(result)
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init = () => {
    const { obj } = this.props;

    const { yearMonth, planAcademicYear, highSchoolCode } = obj;
    const { row } = this.state;
    row.YearMonth = yearMonth;
    row.PlanAcademicYear = planAcademicYear;
    row.HighSchoolCode = highSchoolCode;
    this.setState({ row });

    this.api_list_source_depart();
  };

  setTargetdeparts = (value) => {
    this.api_list_target_depart(value);
  };

  setTargetprincipals = (value) => {
    this.api_list_target_principal(value);
  };

  // 操作互動處理 //////////////////////////////////////////////

  handleChange(event) {
    const { row } = this.state;
    Object.keys(row).forEach((propertyName) => {
      if (event.target.id === propertyName && event.target.value !== null) {
        row[propertyName] = event.target.value.trim();
      }
    });
    this.setState({ row });
  }

  handleCollegeChange = (value) => {
    this.setState({
      selectedCollege: value,
      selectedTargetdepart: "NONE",
      selectedTargetprincipal: "NONE",
    });
    this.setTargetdeparts(value);
    //console.log(value);
  };

  handleTargetdepartChange = (value) => {
    this.setState({
      selectedTargetdepart: value,
      selectedTargetprincipal: "NONE",
    });
    this.setTargetprincipals(value);
  };

  handleTargetprincipalChange = (value) => {
    this.setState({
      selectedTargetprincipal: value,
    });
  };

  handleAcademicSystem = (value) => {
    this.setState({
      selectedAcademicSystem: value,
    });
  };

  handleSourceCode = (value) => {
    this.setState({
      selectedSourceCode: value,
    });
  };

  handleSourceDepartmentCodeChange = (value) => {
    this.setState({
      selectedSourceDepartmentCode: value,
    });
  };

  handleNumberOfPeople = (value) => {
    this.setState({
      setNumberOfPeople: value,
    });
  };

  handleSubmit(event) {
    event.preventDefault();
    const {
      selectedCollege,
      selectedTargetdepart,
      selectedTargetprincipal,
      selectedAcademicSystem,
      selectedSourceCode,
      selectedSourceDepartmentCode,
    } = this.state;

    const errors = [];

    if (selectedCollege === "NONE") {
      errors.push("規劃學院未選");
    }

    if (selectedTargetdepart === "NONE") {
      errors.push("規劃系所未選");
    }

    if (selectedTargetprincipal === "NONE") {
      errors.push("負責人未選");
    }

    if (selectedAcademicSystem === "NONE") {
      errors.push("招收學制未選");
    }

    if (selectedSourceCode === "NONE") {
      errors.push("招收來源未選");
    }
    if (selectedSourceDepartmentCode === "NONE") {
      errors.push("來源科班未選");
    }
    const row = this.state.row;
    if (row.NumberOfPeople === 0) {
      errors.push("規劃員額不能少於一人");
    }

    if (errors.length === 0) {
      const { userCode } = this.props.user;

      row.CollegeCode = selectedCollege;
      row.AcademicSystem = selectedAcademicSystem;
      row.TargetDepartmentCode = selectedTargetdepart;
      row.PrincipalCode = selectedTargetprincipal;
      row.SourceCode = selectedSourceCode;
      row.SourceDepartmentCode = selectedSourceDepartmentCode;
      row.RecordEditorId = userCode;
      row.RecordCreatorId = userCode;
      //console.log(row);
      this.api_add_item(row);
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  }

  //////////////////////////////////////////////////////////

  render() {
    const {
      colleges,
      targetdepartlist,
      targetprincipals,
      academicSystems,
      sourceCodes,
      sourcedeparts,
      selectedCollege,
      selectedTargetdepart,
      selectedAcademicSystem,
      selectedSourceCode,
      selectedSourceDepartmentCode,
      selectedTargetprincipal,
    } = this.state;
    const { NumberOfPeople } = this.state.row;

    const listTargetdeparts =
      targetdepartlist.length > 0 ? (
        <>
          {targetdepartlist.map((item) => (
            <Option key={item.value} value={item.value}>
              {item.label}
            </Option>
          ))}
        </>
      ) : (
        ""
      );

    const listTargetprincipals =
      targetprincipals.length > 0 ? (
        <>
          {targetprincipals.map((item) => (
            <Option key={item.EmployeeId} value={item.EmployeeId}>
              {item.EmployeeId}-{item.TwName}
            </Option>
          ))}
        </>
      ) : (
        ""
      );

    const listSourcedeparts =
      sourcedeparts.length > 0 ? (
        <>
          {sourcedeparts.map((item) => (
            <Option key={item.DepartmentCode} value={item.DepartmentCode}>
              {item.DepartmentName}-可收{item.WillGraduateStudentTotal}人
            </Option>
          ))}
        </>
      ) : (
        ""
      );

    return (
      <Card>
        <form onSubmit={this.handleSubmit}>
          <div className="form-row">
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>規劃學院
                </label>
                <Select
                  style={{ width: "100%" }}
                  onChange={this.handleCollegeChange}
                  defaultValue={selectedCollege}
                >
                  <Option key={"NONE"} value={"NONE"}>
                    請選擇
                  </Option>
                  {colleges.map((college) => (
                    <Option key={college.value} value={college.value}>
                      {college.label}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>規劃系所
                </label>
                <Select
                  style={{ width: "100%" }}
                  onChange={this.handleTargetdepartChange}
                  defaultValue={selectedTargetdepart}
                  allowClear
                >
                  <Option key={"NONE"} value={"NONE"}>
                    請選擇
                  </Option>
                  {listTargetdeparts}
                </Select>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>負責人
                </label>
                <Select
                  style={{ width: "100%" }}
                  onChange={this.handleTargetprincipalChange}
                  defaultValue={selectedTargetprincipal}
                  allowClear
                >
                  <Option key={"NONE"} value={"NONE"}>
                    請選擇
                  </Option>
                  {listTargetprincipals}
                </Select>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-2">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>招收學制
                </label>
                <Select
                  style={{ width: "100%" }}
                  onChange={this.handleAcademicSystem}
                  defaultValue={selectedAcademicSystem}
                >
                  <Option key={"NONE"} value={"NONE"}>
                    請選擇
                  </Option>
                  {academicSystems.map((college) => (
                    <Option key={college.value} value={college.value}>
                      {college.label}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>招收來源
                </label>
                <Select
                  style={{ width: "100%" }}
                  onChange={this.handleSourceCode}
                  defaultValue={selectedSourceCode}
                >
                  <Option key={"NONE"} value={"NONE"}>
                    請選擇
                  </Option>
                  {sourceCodes.map((college) => (
                    <Option key={college.value} value={college.value}>
                      {college.label}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>來源科班
                </label>
                <Select
                  style={{ width: "100%" }}
                  onChange={this.handleSourceDepartmentCodeChange}
                  defaultValue={selectedSourceDepartmentCode}
                  allowClear
                >
                  <Option key={"NONE"} value={"NONE"}>
                    請選擇
                  </Option>
                  {listSourcedeparts}
                </Select>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>招收員額
                </label>
                <input
                  type="number"
                  className="form-control text-primary"
                  style={{ backgroundColor: "LightYellow" }}
                  name="NumberOfPeople"
                  id="NumberOfPeople"
                  defaultValue={NumberOfPeople}
                  aria-describedby="mobileHelp"
                  placeholder="請輸人數"
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <input
              type="submit"
              value="新增"
              className="btn btn-primary btn-sm btn-block"
            />
          </div>
        </form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StudentSourceAddModal);
